import { MailX } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { SkmBlast, SKM_CONTACT_STATUS_BADGE, fmt } from "./_types";

interface Props {
  skm_blasts: SkmBlast[];
}

export default function SkmTab({ skm_blasts }: Props) {
  return (
    <div className="space-y-4">
      {skm_blasts.length === 0 ? (
        <p className="text-sm text-gray-400 text-center py-16">No SKM blasts sent yet.</p>
      ) : (
        skm_blasts.map((blast) => (
          <Card key={blast.id}>
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between">
                <CardTitle className="text-sm">
                  Blast — {blast.sent_at ? fmt(blast.sent_at) : "Not yet sent"}
                </CardTitle>
                <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${
                  blast.status === "sent"     ? "bg-green-100 text-green-700" :
                  blast.status === "approved" ? "bg-blue-100 text-blue-700" :
                  "bg-gray-100 text-gray-500"
                }`}>{blast.status}</span>
              </div>
              <p className="text-xs text-gray-400">{blast.contact_count} contact{blast.contact_count !== 1 ? "s" : ""}</p>
            </CardHeader>
            {blast.contacts.length > 0 && (
              <CardContent className="pt-0">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="text-gray-400 border-b border-gray-100">
                      <th className="text-left py-1.5 font-medium">Contact</th>
                      <th className="text-left py-1.5 font-medium">Firm</th>
                      <th className="text-left py-1.5 font-medium">Status</th>
                      <th className="text-left py-1.5 font-medium">Responded</th>
                    </tr>
                  </thead>
                  <tbody>
                    {blast.contacts.map((bc) => (
                      <tr key={bc.id} className="border-b border-gray-50 last:border-0">
                        <td className="py-1.5 text-gray-800">{bc.contact_name}</td>
                        <td className="py-1.5 text-gray-500">{bc.firm_name}</td>
                        <td className="py-1.5">
                          <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded capitalize ${SKM_CONTACT_STATUS_BADGE[bc.status] ?? "bg-gray-100 text-gray-500"}`}>
                            {bc.status === "bounced" && <MailX className="w-3 h-3" />}
                            {bc.status.replace(/_/g, " ")}
                          </span>
                        </td>
                        <td className="py-1.5 text-gray-400">{bc.responded_at ? fmt(bc.responded_at) : "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </CardContent>
            )}
          </Card>
        ))
      )}
    </div>
  );
}
